<div class="mb-1 container-fluid">
  <div class="row">
    <div class="col-10">
      <div class="row g-2">
        <div class="col-1 header-icon">
          <i [ngClass]="iconClass()" class="header-icon"></i>
        </div>
        <div class="col-2 dropdown">
          <div ngbDropdown>
            <button
              class="btn btn-outline-primary btn-sm form-control"
              id="dropdownBasic1"
              ngbDropdownToggle
            >
              {{ dropdownText() }}
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
              @for (option of dropdownOptions(); track option; let i = $index) {
                <button ngbDropdownItem (click)="dropdownSelected(option)">
                  {{ option }}
                </button>
              }
            </div>
          </div>
        </div>
        <div class="col-2">
          @if (displayFilterInput()) {
            <input
              class="form-control form-control-sm"
              type="search"
              placeholder="{{ filterInputPlaceholder() }}"
              [formControl]="filterInput"
            />
          }
        </div>
        <div class="col-2">
          @if (displayDateFilter()) {
            <div class="input-group">
              <input
                ngbDatepicker
                #datepickerMDY="ngbDatepicker"
                class="form-control form-control-sm mb-2"
                placeholder="{{ dateFilterPlaceholder() }}"
                [formControl]="dateFilter"
                placement="bottom"
                container="body"
              />
              <button
                class="btn btn-sm btn-secondary mb-2"
                (click)="datepickerMDY.toggle()"
                [attr.aria-expanded]="datepickerMDY.isOpen()"
                type="button"
              >
                <i class="bi bi-calendar3"></i>
              </button>
            </div>
          }
          @if (displayModalButton()) {
            <button
              class="btn btn-success btn-sm btn-open-modal"
              type="button"
              (click)="openModal()"
            >
              {{ modalButtonText() }}
            </button>
          }
        </div>
      </div>
    </div>

    <div class="col-2">
      <button
        class="btn btn-sml btn-link d-block float-end"
        type="button"
        (click)="exportExcel()"
      >
        Export
        <i class="bi bi-file-earmark-excel-fill export-icon"></i>
      </button>
      @if (displayCustomButton()) {
        <button
          class="btn btn-success btn-sm m-1 float-end"
          style="width: 75px"
          type="button"
          (click)="onCustomButtonClick()"
        >
          {{ customButtonText() }}
        </button>
      }
    </div>
  </div>
</div>
